import * as styles from "./ButtonGroup.css";

import { clsx } from "clsx";
import type { JSX } from "react";

type ButtonGroupProps = React.ComponentProps<"div">;

export function ButtonGroup({
  children,
  className,
  ...props
}: ButtonGroupProps): JSX.Element {
  return (
    <div
      data-slot="button-group"
      className={clsx(styles.buttonGroup, className)}
      {...props}
    >
      {children}
    </div>
  );
}
